import { Component, DestroyRef, OnInit, signal, inject } from '@angular/core';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { ObjectTypes } from '@fi-shared/types';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { FiTagsListPositionTypes } from '@fi-app/components/items-list/enums';
import { FiItemsListType } from '@fi-app/shared/fi-items-list/fi-items-list-type';
import { UserPreferencesService } from '@fi-shared/fi-shared-services/user-preferences.service';
import { FiDisplayType } from '@fi-app/shared/types/display-type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
    selector: 'fi-document-list-view-state',
    template: `
        <fi-document-list [displayType]="currentListDisplayType()" />

        <!-- @if (loading()) {
            <div class="text-center">
                <fi-loading class="small" />
            </div>
        } @else {
            @if (documentListViewSettings$ | async; as documentListViewSettings) {
                <fi-document-list-view
                    [documentListViewSettings]="documentListViewSettings"
                    [isItemActionsShown]="true"
                ></fi-document-list-view>
            }
        } -->
    `,
    styleUrls: ['./document-list-view-state.component.scss'],
    standalone: false,
})
export class DocumentListViewStateComponent implements OnInit {
    protected loading = signal<boolean>(false);
    protected tagsPositionType: FiTagsListPositionTypes = FiTagsListPositionTypes.Left;

    // documentListViewSettings$ = new ReplaySubject<ListViewSettingModel>(1);
    // private stateAccessCheckService = inject(StateAccessCheckService);
    // private listViewSettingsService = inject(ListViewSettingsService);
    private statisticService = inject(StatisticService);
    private userPreferencesService = inject(UserPreferencesService);
    private destroyRef = inject(DestroyRef);

    protected currentListDisplayType = signal<FiDisplayType>(
        this.userPreferencesService.getListDisplayType(FiItemsListType.Documents) ?? FiDisplayType.List,
    );

    public ngOnInit(): void {
        // this.listViewSettingsService
        //     .getSetting(ObjectTypes.Document)
        //     .then((listViewSettings: ListViewSettingModel) => {
        //         this.tagsPositionType = listViewSettings.PositionType;
        //     })
        //     .finally(() => this.loading.set(false));
        this.subscribeToUserPreferencesService();
        this.statisticService.Visit(ModuleType.Document);
    }

    private subscribeToUserPreferencesService(): void {
        this.userPreferencesService
            .onListDisplayTypeUpdate$()
            .pipe(
                filter((type) => type === FiItemsListType.Documents),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe(() => {
                this.currentListDisplayType.set(
                    this.userPreferencesService.getListDisplayType(FiItemsListType.Documents),
                );
            });
    }
}
